<template>
	<div class="audio-wrap">
		<audio
			:src="publicPath + 'static/uploads/' + audiodata['url']"
			controls
		></audio>
		<!-- <div class="audio-custom">
			<span class="play-icon" v-bind:class="{ playing: playing }"></span>
		</div> -->
		<div class="ring-wrap" v-on:click.prevent="playing = !playing">
			<svg class="progress-ring" width="36" height="36">
				<circle
					class="progress-ring__circle"
					stroke="black"
					stroke-width="1"
					r="18"
					fill="transparent"
					v-bind:style="
						'stroke-dasharray: ' +
							circumference +
							', ' +
							circumference +
							'; stroke-dashoffset: ' +
							svgoffset +
							';'
					"
				/>
			</svg>
			<span class="play-icon" v-bind:class="{ playing: playing }"></span>
		</div>
	</div>
</template>

<script>
const convertTimeHHMMSS = val => {
	let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

	return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
};
export default {
	data() {
		return {
			publicPath: process.env.BASE_URL,
			radius: 18,
			circumference: 0,
			offset: 0,

			currentSeconds: 0,
			durationSeconds: 0,
			innerLoop: false,
			loaded: false,
			playing: false,
			previousVolume: 35,
			showVolume: false,
			volume: 100
		};
	},
	computed: {
		currentTime() {
			return convertTimeHHMMSS(this.currentSeconds);
		},
		durationTime() {
			return convertTimeHHMMSS(this.durationSeconds);
		},
		percentComplete() {
			return parseInt((this.currentSeconds / this.durationSeconds) * 100);
		},
		muted() {
			return this.volume / 100 === 0;
		},
		svgoffset() {
			return (
				this.circumference -
				(this.percentComplete / 100) * this.circumference
			);
		}
	},
	watch: {
		playing(value) {
			if (value) {
				return this.audio.play();
			}
			this.audio.pause();
		}
	},
	mounted() {
		this.circumference = this.radius * 2 * Math.PI;

		this.audio = this.$el.querySelectorAll("audio")[0];
		this.audio.addEventListener("timeupdate", this.update);
		this.audio.addEventListener("loadeddata", this.load);
		this.audio.addEventListener("pause", () => {
			this.playing = false;
		});
		this.audio.addEventListener("play", () => {
			this.playing = true;
		});
	},
	props: ["audiodata"],
	methods: {
		load() {
			if (this.audio.readyState >= 2) {
				this.loaded = true;
				this.durationSeconds = parseInt(this.audio.duration);
				return (this.playing = this.autoPlay);
			}

			throw new Error("Failed to load sound file.");
		},
		mute() {
			if (this.muted) {
				return (this.volume = this.previousVolume);
			}

			this.previousVolume = this.volume;
			this.volume = 0;
		},
		seek(e) {
			if (!this.playing || e.target.tagName === "SPAN") {
				return;
			}

			const el = e.target.getBoundingClientRect();
			const seekPos = (e.clientX - el.left) / el.width;

			this.audio.currentTime = parseInt(this.audio.duration * seekPos);
		},
		stop() {
			this.playing = false;
			this.audio.currentTime = 0;
		},
		update() {
			this.currentSeconds = parseInt(this.audio.currentTime);
		}
	}
};
</script>

<style lang="scss">
.audio-wrap {
	max-width: 560px;
	margin: 15px auto 0;
	width: 100%;
	.isOpen & {
		margin: 0 auto 30px;
	}
	audio {
		width: 100%;
		position: absolute;
		opacity: 0;
		width: 20px;
		.isOpen & {
			position: relative;
			width: 100%;
			opacity: 1;
		}
	}

	// 

	// audio::-webkit-media-controls-fullscreen-button,
	// audio::-webkit-media-controls-mute-button, 
	// audio::-webkit-media-controls-volume-slider-container,
	// audio::-webkit-media-controls-volume-slider,
	// audio::-webkit-media-controls-toggle-closed-captions-button,
	// audio::-webkit-media-controls-panel
	// { display:none !important; }

	// audio::-webkit-media-controls-play-button

	// audio::-webkit-media-controls-timeline-container

	// audio::-webkit-media-controls-current-time-display

	// audio::-webkit-media-controls-time-remaining-display

	// audio::-webkit-media-controls-timeline

	// audio::-webkit-media-controls-seek-back-button

	// audio::-webkit-media-controls-seek-forward-button


	// audio::-webkit-media-controls-rewind-button

	// audio::-webkit-media-controls-return-to-realtime-button

}
.ring-wrap {
	display: block;
	position: relative;
	width: 36px;
	height: 36px;
	margin-left: auto;
	margin-right: auto;
	.isOpen & {
		display: none;
	}
	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		border: solid 1px rgba(0, 0, 0, 0.1);
	}
	svg {
		position: absolute;
		top: -18px;
		left: 18px;
		overflow: visible;
	}
	span.play-icon {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		
		

		box-sizing: border-box;
		height: 14px;
		border-color: transparent transparent transparent #202020;
		border-style: solid;
		border-width: 7px 0 7px 12px;
		margin-left:2px;
		&.playing {
			width: 10px;
			border: none;
			border-left: solid 3px black;
			border-right: solid 3px black;
			height: 15px;
			margin-left: 0;
		}
	}
}
.progress-ring {
}

.progress-ring__circle {
	transition: 0.35s stroke-dashoffset;
	// axis compensation
	transform: rotate(-90deg);
	transform-origin: 50% 50%;
}
</style>
